import React from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom';
import Layout from '../components/layout/Index'
import AuthRoutes from './AuthRoutes';
import Dashboard from '../pages/Dashboard/Index';
import ExternalLogin from '../pages/ExternalLogin/ExternalLogin';
import RaiseClaim from '../pages/RaiseClaim';
import NotFound from '../pages/NotFound';
import RaiseClaimSummary from '../pages/RaiseClaimSummary';
import Profile from '../pages/Profile';

const basename = process.env.REACT_APP_BASE_URL;

export default function AppRoutes() {
    return (
        <BrowserRouter basename={basename}>
            <Routes>
                <Route element={<AuthRoutes />}>
                    <Route path="" element={<Navigate to="/External/dashboard" />} />
                    <Route path="External" element={<Layout />} >
                        <Route path="dashboard" element={<Dashboard />} />
                        <Route path="raise-claim" element={<RaiseClaim />} />
                        <Route path="raise-claim-summary" element={<RaiseClaimSummary />} />
                        <Route path="profile" element={<Profile />} />
                        <Route path="*" element={<NotFound />} />
                    </Route>
                </Route>
                <Route path="/ExternalLogin" element={<ExternalLogin />} />
                <Route path="/external/verify-user" element={<ExternalLogin />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </BrowserRouter>
    )
}
